export default "__VITE_ASSET__B_yspO80__"